import React from "react";
import styled from "styled-components";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { NavLink, To } from "react-router-dom";

interface ButtonDropdownProps {
  children: React.ReactNode;
  list: {
    label: React.ReactNode;
    to?: To;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    width?: string;
    justifyContent?: string;
  }[];
}

const ButtonDropdown = ({ children, list }: ButtonDropdownProps) => {
  return (
    <DropdownMenu.Root>
      <DropdownTriggerStyle>{children}</DropdownTriggerStyle>

      <DropdownMenuStyle>
        {list.map((item, index) =>
          item.to ? (
            <NavLink key={index} to={item.to}>
              <DropdownItemStyle
                key={index}
                style={{
                  width: item.width ?? "20rem",
                  justifyContent: item.justifyContent ?? "center",
                }}
                onClick={item.onClick}
              >
                {item.label}
              </DropdownItemStyle>
            </NavLink>
          ) : (
            <DropdownItemStyle
              key={index}
              onClick={item.onClick}
              style={{
                width: item.width ?? "20rem",
                justifyContent: item.justifyContent ?? "center",
              }}
            >
              {item.label}
            </DropdownItemStyle>
          ),
        )}
      </DropdownMenuStyle>
    </DropdownMenu.Root>
  );
};

export default ButtonDropdown;

const DropdownTriggerStyle = styled(DropdownMenu.Trigger)`
  outline: none;
`;

const DropdownMenuStyle = styled(DropdownMenu.Content)`
  display: inline-flex;
  padding: 1.2rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;

  border-radius: 1.6rem;
  background: ${({ theme }) => theme.color.background.white};
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);

  z-index: ${({ theme }) => theme.zIndex.dropdown};

  & a.active > div {
    background: ${({ theme }) => theme.color.background.dark};
    color: ${({ theme }) => theme.color.text.highEmphasis};
  }
`;

const DropdownItemStyle = styled(DropdownMenu.Item)`
  display: flex;
  padding: 1.2rem 1.4rem;
  align-items: center;
  gap: 1rem;

  outline: none;
  color: ${({ theme }) => theme.color.text.secondary};
  ${({ theme }) => theme.typography.body1.regular}
  letter-spacing: -0.048rem;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.background.dark};
  }
`;
